import AuthForm from "../components/form/AuthForm.jsx";

const LogInPage = () => {
  return (
    <>
      <div>
        <AuthForm isLogin />
      </div>
    </>
  );
};

export default LogInPage;
